/**
 * Logo component - displays application branding with icon
 * Clickable logo that navigates to Dashboard
 */

import { Link } from 'react-router-dom'

interface LogoProps {
  className?: string
  showIcon?: boolean
  showText?: boolean
}

/**
 * Logo component with clickable navigation to Dashboard
 * @param className - Optional additional CSS classes
 * @param showIcon - Whether to show the icon (default: true)
 * @param showText - Whether to show the text (default: true)
 */
export function Logo({ className = '', showIcon = true, showText = true }: LogoProps) {
  return (
    <Link
      to="/"
      className={`flex items-center gap-2 text-xl sm:text-2xl font-bold text-foreground hover:text-primary transition-colors ${className}`}
      aria-label="Gold Tracker - Trang chủ"
    >
      {showIcon && (
        <img
          src="/icons/favicon-32x32.png"
          alt="Gold Tracker Logo"
          className="w-6 h-6 sm:w-7 sm:h-7"
          style={{ borderRadius: 6 }}
          width="24"
          height="24"
        />
      )}
      {showText && <span>Gold Tracker</span>}
    </Link>
  )
}
